<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.calendar_new.title')"
            back
        />
        <v-row>
            <v-col cols="12">
                <CalendarForm
                    :data="data"
                    :raw-data="rawData"
                    :errors="formErrors"
                    :save-function="saveObject"
                    :discard-function="resetObject"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import PageHeader from '@/components/common/PageHeader';
import CalendarForm from '@/components/calendar/Form/CalendarForm';
import CalendarProxy from '@/proxies/CalendarProxy';
import CalendarMixin from '@/mixins/calendar';
import { StandBy, SuccessSnackbar } from '@/app-events.js';

export default {
    name: 'CalendarNew',
    mixins: [ CalendarMixin ],
    components: {
        PageHeader,
        CalendarForm,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.calendar.title'),
                    exact: true,
                    to: { name: 'calendar' },
                },
                {
                    text: this.$t('general.new'),
                    disabled: true,
                },
            ],
            data: {

            },
            rawData: {},
        };
    },
    created() {
        if (typeof this.$route.params.weekDay !== 'undefined') {
            const weekDay = this.$route.params.weekDay.split('-');
            let str = this.$route.params.weekDay;
            let split = str.lastIndexOf('-');
            let selectedDay = str.substring(split+1);
            let selectedWeek = str.substring(0,split);
            this.data = {
                week: selectedWeek,
                day: parseInt(selectedDay),
            };
            this.rawData = {
                week: selectedWeek,
                day: parseInt(selectedDay),
            };
        }
    },
    methods: {
        saveObject() {
            if (JSON.stringify(this.data) === JSON.stringify(this.rawData)) {
                return;
            }
            this.$eventBus.dispatch(new StandBy(true));
            new CalendarProxy().new(this.prepareFormData(this.data)).then(({ data }) => {
                this.$eventBus.dispatch(new StandBy(false));
                this.$eventBus.dispatch(new SuccessSnackbar(this.$t('calendar.actions.created')));
                this.$router.push({ name: 'calendar_detail', params: { id: data.data.id } });
            }).catch(({ data }) => {
                this.processErrors(data);
                this.$eventBus.dispatch(new StandBy(false));
            });
        }
    },
};
</script>
